import React, { useState } from 'react';
import { Search, ShoppingCart, Menu, X, ChevronRight, Check, Star, Clock, Shield, Smartphone } from 'lucide-react';

// Navigation Component
const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <h1 className="text-xl font-semibold tracking-tight">Josie</h1>
            <div className="hidden md:flex space-x-6">
              <a href="#" className="text-sm hover:text-gray-600 transition">Shop</a>
              <a href="#" className="text-sm hover:text-gray-600 transition">Flash Deals</a>
              <a href="#" className="text-sm hover:text-gray-600 transition">Trade-in</a>
              <a href="#" className="text-sm hover:text-gray-600 transition">Gift Cards</a>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="hidden sm:flex items-center bg-gray-100 rounded-full px-4 py-2">
              <Search className="w-4 h-4 text-gray-400 mr-2" />
              <input 
                type="text" 
                placeholder="Search..." 
                className="bg-transparent text-sm outline-none w-32 lg:w-48"
              />
            </div>
            <button className="p-2 hover:bg-gray-100 rounded-full transition">
              <ShoppingCart className="w-5 h-5" />
            </button>
            <button 
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>
      
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-4 space-y-3">
            <a href="#" className="block text-sm py-2">Shop</a>
            <a href="#" className="block text-sm py-2">Flash Deals</a>
            <a href="#" className="block text-sm py-2">Trade-in</a>
            <a href="#" className="block text-sm py-2">Gift Cards</a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation